import {
  EMessagingLimit,
  EQualityScore,
  EQualityStatus,
  EWabaStatus,
} from 'src/containers/Channels/definitions';
import {EResellerIds} from 'src/containers/User';

import {TFacebookSDKConfig} from './Facebook';

const DEV_CONFIG_ID = '755997426647668';
const PROD_CONFIG_ID = '791330699428621';

const facebookSDKConfig: TFacebookSDKConfig = {
  DEV_APP_ID: '683278246995247',
  PROD_APP_ID: '2026253854199025',
};

const NAME_MAX_LENGTH = 512;
const LOGO_SIZE = 400;
const LOGO_FORMATS = '.jpg, .jpeg';

type TWhatsAppChannel = {
  id: number;
  name: string;
  type: EFormType;
  status: EStatus;
  availableTariffId?: number;
  phone?: string;
  address?: string;
  email?: string;
  logoFile?: TFile | null;
  contactStatus?: string;
  coexistence?: boolean;
  // quality
  qualityScore: EQualityScore | null;
  messagingLimit?: EMessagingLimit;
  previousQualityScore?: EQualityScore;
  previousMessagingLimit?: EMessagingLimit;
  qualityStatus?: EQualityStatus | null;
  qualityUpdatedAt: string;
  // WABA restrictions
  wabaId?: number;
  wabaViolationType?: string;
  wabaRestrictionExpirationDate?: string;
  wabaStatus?: EWabaStatus;
  marketingMessagesApiTermsSigned?: boolean;
};

type TMauInfo = {
  tariffMauCount: number;
  remainingMauCount: number;
  amauCount?: number;
};

type TSubscribersMauInfo = {
  mauCountWillBeSpent: number;
  currentRemainingMauCount: number;
  amauCountWillBeSpent: number;
};

type TTechPartnerChannel = {
  id: number;
  name: string;
  code: string;
  status: EStatus;
  availableTariffId: number;
  coexistence?: boolean;
};

enum EPublicStatus {
  NEW = 'NEW',
  SUCCESS = 'SUCCESS',
  ERROR_OLD_CODE = 'ERROR_OLD_CODE',
  ERROR_INCORRECT_TARIFF = 'ERROR_INCORRECT_TARIFF',
  ERROR_USED_CODE = 'ERROR_USED_CODE',
}

type TPublicChannel = {
  id: number;
  partnerName: string;
  status: EPublicStatus;
  resellerId: EResellerIds;
  coexistence?: boolean;
};

type TFormData = {
  id?: TWhatsAppChannel['id'];
  name?: TWhatsAppChannel['name'];
  address?: TWhatsAppChannel['address'];
  email?: TWhatsAppChannel['email'];
  phone?: TWhatsAppChannel['phone'];
  code?: string;
  availableTariffId?: TWhatsAppChannel['availableTariffId'] | null;
  logoFile?: TWhatsAppChannel['logoFile'];
  contactStatus?: TWhatsAppChannel['contactStatus'];
  coexistence?: TWhatsAppChannel['coexistence'];
  wabaId?: number;
};

type TTechPartnerChannelFormData = {
  id?: TTechPartnerChannel['id'];
  name?: TTechPartnerChannel['name'];
  availableTariffId?: TTechPartnerChannel['availableTariffId'] | null;
  code?: TTechPartnerChannel['code'];
  coexistence?: boolean;
};

type TPublicChannelFormData = {
  address?: TWhatsAppChannel['address'];
  logoFile?: TWhatsAppChannel['logoFile'] | null;
  email?: TWhatsAppChannel['email'];
  contactStatus?: TWhatsAppChannel['contactStatus'];
  code?: TTechPartnerChannel['code'];
  wabaId?: number;
};

enum EFormType {
  MAIN = 'MAIN',
  PARTNER = 'PARTNER',
}

enum EStatus {
  // ui only statuses
  UI_NEED_TARIFF_TEMPLATE_ID = 'UI_NEED_TARIFF_TEMPLATE_ID',

  NEW = 'NEW',
  DRAFT = 'DRAFT',
  SENT_TO_PLATFORM = 'SENT_TO_PLATFORM',
  BUSINESS_VERIFICATION_EXPIRED = 'BUSINESS_VERIFICATION_EXPIRED',
  DONE_FINISH_REGISTER = 'DONE_FINISH_REGISTER',
  DONE_BUSINESS_VERIFICATION = 'DONE_BUSINESS_VERIFICATION',
  CANCELLED = 'CANCELLED',
  DISABLED = 'DISABLED',
  DELETED = 'DELETED',
}

const DEFAULT_VALUES: TFormData = {
  name: '',
  availableTariffId: null,
  address: '',
  contactStatus: '',
  email: '',
  logoFile: null,
};

const TECH_PARTNER_CHANNEL_DEFAULT_VALUES: TTechPartnerChannelFormData = {
  name: '',
  availableTariffId: null,
};

const PUBLIC_CHANNEL_DEFAULT_VALUES: TPublicChannelFormData = {
  address: '',
  email: '',
  contactStatus: '',
  logoFile: null,
};

enum EFormSteps {
  SETTINGS = 'SETTINGS',
  VIEW = 'VIEW',
}

export type {
  TWhatsAppChannel,
  TMauInfo,
  TFormData,
  TTechPartnerChannel,
  TTechPartnerChannelFormData,
  TPublicChannel,
  TPublicChannelFormData,
  TSubscribersMauInfo,
};

export {
  EFormSteps,
  facebookSDKConfig,
  DEV_CONFIG_ID,
  PROD_CONFIG_ID,
  EStatus,
  EFormType,
  EPublicStatus,
  NAME_MAX_LENGTH,
  LOGO_SIZE,
  LOGO_FORMATS,
  DEFAULT_VALUES,
  TECH_PARTNER_CHANNEL_DEFAULT_VALUES,
  PUBLIC_CHANNEL_DEFAULT_VALUES,
};
